<template>
  <div class="site-menu">
    <div class="">
      <div class="site-sub-menu" :style="{ 'max-height': maxHeight }">
        <div
          class="menu-btn"
          v-for="(s, index) in sites"
          :key="index"
          :class="{ actived: index === actived }"
          @click="setSite(index)"
        >
          <i
            class="el-icon-location-information menu-btn-icon text-success"
          ></i>
          <span class="menu-btn-label">{{ s.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import jData from '@/assets/sites.json'
import { getJson } from '@/service/site'

export default {
  data() {
    return {
      maxHeight: `0px`,
      actived: 0,
      sites: []
    }
  },
  async mounted() {
    const sites = await this.getSites()
    this.sites = sites
    this.$emit('site-change', this.sites[0])
    this.setMaxHeight(this.sites)
  },
  methods: {
    async getSites() {
      try {
        const json = await getJson(this.companyId)
        return json
      } catch (e) {
        console.log(e)
        return []
      }
    },
    setMaxHeight(sites) {
      this.maxHeight = sites && sites.length ? `${sites.length * 80}px` : 0
    },
    setSite(index) {
      if (this.actived !== index) {
        this.actived = index
        this.$emit('site-change', this.sites[index])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '~@/assets/css/variables.scss';
.site-menu {
  position: absolute;
  top: 150px;
  left: 20px;
  z-index: 100;
}
.menu-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6px;
  margin-left: 0;
  padding: 8px 0 6px;
  min-height: 40px;
  width: 64px;
  height: auto;
  font-size: 12px;
  pointer-events: auto;
  flex-direction: column;
  user-select: auto;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  color: #f3f1f1;
  border: 1px solid #84aaf15e;
  background-color: #84aaf15e;
  &.actived .menu-btn-icon {
    color: #e39505;
  }
  &:hover {
    background-color: #9aa8d4;
  }
  .menu-btn-label {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    padding: 0 8px;
  }
  .menu-btn-icon,
  i {
    font-size: 1.5rem;
    width: 20px;
    height: 20px;
    margin-bottom: 8px;
  }
}
.site-sub-menu {
  max-height: 500px;
  overflow: hidden;
  transition: all 0.2s ease;
}
</style>
